/**
 * DIV-001 — the window.jQuery bridge (PARITY-STATUS.md "Deliberate
 * divergences").
 *
 * Historically the bundle's ~180 `window.jQuery(...)` call sites required
 * the THEME to ship jQuery; on themes without it (Dawn family) the
 * calculator never rendered (NOJQ-001-old). DIV-001 bridged window.jQuery
 * to the bundled copy when the theme provided none.
 *
 * Since DIV-004 the bundle never CONSUMES window.jQuery — every internal
 * call site imports the bundled `$` directly (exposed as the non-enumerable
 * window.cpc.$). This bridge is now OUTWARD-ONLY compatibility: stores/
 * themes that started relying on window.jQuery existing (it has been set on
 * jQuery-less themes since DIV-001 shipped) keep working. A theme that
 * loads its own jQuery later simply overwrites the bridge — irrelevant to
 * us (LAZYJQ-001).
 */
import $ from "jquery";

export function installJqueryFallback(): void {
  if (typeof window.jQuery === "undefined") {
    window.jQuery = $;
  }
}
